const actionTypes = require('constants/actionTypes');
const { APIGet } = require('utilities/APIRequestHelper');

const requestSharedAccountsInProgress = () => ({
    type: actionTypes.REQUEST_SHARED_ACCOUNTS_REQUEST,
});

const requestSharedAccountsSuccess = data => ({
    type: actionTypes.REQUEST_SHARED_ACCOUNTS_SUCCESS,
    data
});

const requestSharedAccountsError = error => ({
    type: actionTypes.REQUEST_SHARED_ACCOUNTS_FAILURE,
    error
});

const requestSharedAccounts = () => (dispatch, getState) => {
    const currentState = getState().sharedAccounts;
    const isAlreadyFetching = currentState.get('isFetching');

    if (!isAlreadyFetching) {
        dispatch(requestSharedAccountsInProgress());
        return APIGet({
            dispatch,
            endpoint: 'sharedAccounts'
        })
        .then(response => {
            dispatch(requestSharedAccountsSuccess(response.data));
        })
        .catch(response => {
            dispatch(requestSharedAccountsError(response.error));
        });
    } else {
        return Promise.resolve();
    }
};

module.exports = {
    requestSharedAccounts
};
